import * as React from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import ModalContainer from '@af-common/Common/_containers/ModalContainer';
import { Trans } from 'react-i18next';

export type Props = {
	label: React.ReactNode
	color?: string
	onColorChange?: (color: ColorResult) => void
}

type State = {
	opened: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class SimplePicker extends React.Component<Props, State> {
	private modal:React.RefObject<ModalContainer>;
	state = {opened: false}
	
	constructor(props:Props, state:State){
		super(props, state);
		this.modal = React.createRef();
	}

	private open = () => this.setState({opened: true})
	private close = () => this.setState({opened: false})

	private stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	render(){
		const swatchStyle = { backgroundColor: this.props.color }
		return <div className={this.state.opened ? 'colorSwatch opened' : 'colorSwatch'}>
			<span>{ this.props.label }</span>
			<div className="inline" onWheel={this.stopPropagation} onMouseDown={this.stopPropagation}>
				<ModalContainer ref={this.modal} opened={this.state.opened} align animate onOpen={this.open} onClose={this.close}
					element={
						<div className="swatch">
							<div style={swatchStyle} />
						</div>
					}
					content={
						<SketchPicker presetColors={[]} color={this.props.color} onChange={ this.props.onColorChange } />
					}
				/>
			</div>
		</div>
	}
}